import { useState, useEffect } from 'react';
import Modal from './Modal';

const PageModal = ({ isOpen, onClose, slug }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && slug) {
      fetchPage();
    }
  }, [isOpen, slug]);

  const fetchPage = async () => {
    if (!slug) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`/api/pages/${slug}`);

      if (response.ok) {
        const data = await response.json();
        setPage(data.data);
      } else if (response.status === 404) {
        setError('Page not found');
      } else {
        setError('Failed to load page');
      }
    } catch (err) {
      console.error('Error fetching page:', err);
      setError('Failed to load page');
    } finally {
      setLoading(false);
    }
  };

  const renderContent = (content) => {
    // Simple HTML rendering - in a real app you might want to use a library like react-html-parser
    // or sanitize the HTML for security
    return { __html: content };
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="95%" title={page?.title || 'Loading...'}>
      <div className="p-6">
        {loading && (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading page...</p>
          </div>
        )}

        {error && (
          <div className="text-center py-12">
            <div className="text-red-500 text-lg font-semibold mb-2">Error</div>
            <p className="text-gray-600">{error}</p>
          </div>
        )}

        {page && !loading && !error && (
          <div className="prose prose-lg max-w-none">
            <div dangerouslySetInnerHTML={renderContent(page.content)} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PageModal;